import styled from '@emotion/styled';

import { fontAritaBuri } from '@/styles/themes/variables';

export const Wrapper = styled.section`
  overflow: hidden;
  height: 0;
  font-family: ${fontAritaBuri};
`;

export const Download = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-image: url('/images/graduate/certificate.png');
  width: 1756px;
  height: 1237px;
`;

export const DownloadText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 300px 0;
`;
export const DownloadName = styled.div`
  z-index: 10;
  font-size: 50px;
  font-weight: 700;
  margin: 96px 0 8px 0;
`;

export const Desc = styled.p`
  z-index: 10;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  line-height: 2;
  margin-top: 20px;
`;

export const GraduateDate = styled.div`
  z-index: 10;
  font-size: 30px;
  font-weight: 500;
  position: relative;
  left: 27.3%;
  bottom: 10%;
`;

export const Ceo = styled.div`
  z-index: 10;
  font-size: 25px;
  font-weight: 400;
  position: relative;
  left: 60.5%;
  bottom: 5.5%;
`;
